export default function Support() {
  return (
    <section id="support" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">We're Here to Help</h2>
          <p className="text-lg text-gray-600">Multiple ways to get the support you need</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-blue-50 rounded-2xl p-8 hover:shadow-xl transition-all cursor-pointer">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-mail-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Email Support</h3>
            <p className="text-base text-gray-600 mb-6">Get detailed answers to your questions</p>
            <a href="mailto:support@surgensrl.com" className="text-lg text-blue-600 font-semibold hover:text-blue-700 transition-colors">
              support@surgensrl.com
            </a>
            <div className="mt-4 inline-block px-3 py-1 bg-blue-100 text-blue-700 text-sm rounded-full">
              Within 24 hours
            </div>
          </div>

          <div className="bg-green-50 rounded-2xl p-8 hover:shadow-xl transition-all cursor-pointer">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-phone-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Phone Support</h3>
            <p className="text-base text-gray-600 mb-6">Speak directly with our team</p>
            <a href="tel:+18555527779" className="text-lg text-green-600 font-semibold hover:text-green-700 transition-colors">
              +1 855-552-7779
            </a>
            <div className="mt-4 inline-block px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full">
              Mon-Fri 9AM-6PM EST
            </div>
          </div>

          <div className="bg-purple-50 rounded-2xl p-8 hover:shadow-xl transition-all cursor-pointer">
            <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-book-open-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Knowledge Base</h3>
            <p className="text-base text-gray-600 mb-6">Browse articles and guides</p>
            <button className="px-6 py-2.5 bg-purple-600 text-white text-base font-semibold rounded-full hover:bg-purple-700 transition-all whitespace-nowrap cursor-pointer">
              Visit Help Center
              <i className="ri-external-link-line ml-2"></i>
            </button>
            <div className="mt-4 inline-block px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full">
              100+ Articles
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
